export const numberOfEligibleEmployees = (questions) => {
  const { hasUnionEmployees, numberOfEmployees, numberOfUnionEmployees } =
    questions;

  return hasUnionEmployees.value === 'yes' && numberOfUnionEmployees.dirty
    ? numberOfEmployees.value - numberOfUnionEmployees.value
    : numberOfEmployees.value;
};
